import React, { SVGProps } from "react";

const CrossIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" {...props}>
        <path d="M13 13L1 1" stroke="#F5F5F5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13 1L1 13" stroke="#F5F5F5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </>
  )
};

export default CrossIcon;
